import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonComponent, HeadlineComponent, TextComponent } from '@zeiss/beyond-online-angular';
import { IconComponent, PopUpRef } from 'vis-ods-angular';
import { RoutesEnum } from '../../../../routing/routes.enum';
import { GeneralSuccessMessageComponent } from '../../../../shared/components/general-success-message/general-success-message.component';

@Component({
	selector: 'app-success-message',
	templateUrl:
		'../../../../shared/components/general-success-message/general-success-message.component.html',
	imports: [TranslocoModule, IconComponent, HeadlineComponent, ButtonComponent, TextComponent],
})
export class SuccessMessageComponent extends GeneralSuccessMessageComponent {
	override title: string = 'generalComponents.addedToCardPopUpSuccess.headlines.title';
	override text: string = 'generalComponents.addedToCardPopUpSuccess.texts.question';
	constructor(
		public popUp: PopUpRef,
		private readonly router: Router,
	) {
		super();
	}

	override async goToHome() {
		const routed = await this.router.navigate([RoutesEnum.home]);

		if (routed) {
			this.popUp?.close();
		}
	}
	override goToOrder() {
		this.popUp.close();
	}

	override async goToCart() {
		const routed = await this.router.navigate([RoutesEnum.shoppingCart]);

		if (routed) {
			this.popUp?.close();
		}
	}
}
